import * as moment from 'moment'; // add this 1 of 4

export default class CommonUtils {
    static colors = {};

    static hashCode(str) { // java String#hashCode
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return hash;
    }

    static intToRGB(i) {
        const c = (i & 0x00FFFFFF)
            .toString(16)
            .toUpperCase();

        return '00000'.substring(0, 6 - c.length) + c;
    }

    static getColorForLabel(label){
        this.colors[label] = this.colors[label] || '#' + this.intToRGB(this.hashCode(label));
        return this.colors[label];
    }

    static getObjectValuesArray( obj ) {
      if ( !obj ) {
        return [];
      }
      return Object.keys(obj).map(i => obj[i]);
    }

    static isValidDate(datestr: string){
        return moment(datestr, 'YYYY-MM-DD', true).isValid();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/common.util.ts